const sharedInitialReducerState = {
  data: null,
  error: null,
  status: "loading",
};

export { sharedInitialReducerState };
